import { BroadcasterService } from "./broadcaster.service";
import { CommonModule } from '@angular/common';
import {FormsService} from "./services/forms.service";
import { FormsListService } from "./services/forms-list.service";
import {HttpClientModule} from "@angular/common/http";
import { httpInterceptorProviders } from "./interceptors";
import { LOCALE_ID, ModuleWithProviders, NgModule, Optional, SkipSelf, Type } from '@angular/core';
import { LogLevel } from "./logging/log-entry";
import { LogPublishersService } from "./logging/log-publishers.service";
import { LogService } from "./logging/log.service";
import {OrganizationsService} from "./services/organizations.service";
import { PatientService } from "./services/patient.service";
import { ProcessAbbyyService } from "./services/process-abbyy.service";
import {ProcessBatchService} from "./services/process-batch.service";
import { RequestCache, RequestCacheWithMap } from "./services/request-cache.service";
import { SessionService } from "./services/session.service";
import {LoaderService} from "./services/loader.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    BroadcasterService,
    FormsService,
    FormsListService,
    httpInterceptorProviders,
    LoaderService,
    LogPublishersService,
    LogService,
    OrganizationsService,
    PatientService,
    ProcessBatchService,
    ProcessAbbyyService,
    SessionService,
  ],
  exports: [HttpClientModule]
})
export class CoreModule {
  private static RequestCacheWithMap: Type<any>;
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
          'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
  static forRoot(logLevel: LogLevel): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: 'logLevel', useValue: logLevel }
      ]
    };
  }
  // static forRoot(level: LogLevel): ModuleWithProviders<CoreModule> {
  //   return {
  //     ngModule: CoreModule,
  //     providers: [
  //       {provide: 'logLevel', useValue: level},
  //       // {
  //       //   provide: HTTP_INTERCEPTORS,
  //       //   useClass: AuthInterceptor,
  //       //   multi: true
  //       // },
  //       // {provide: ErrorHandler, useClass: SentryErrorHandler},
  //       {provide: RequestCache, useClass: this.RequestCacheWithMap},
  //       {provide: LOCALE_ID, useValue: 'en'},
  //     ]
  //   };
  // }
}
